// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, bool, object, string } from 'prop-types'
import Radio from './Radio'
import { UpdatedRadioGroupWrapper } from './styles'
import UpdatedInputBase from '../UpdatedInputBase'

// NOTE - this updated version does not offer label or errors support.
// This is intended to create a separation of interest for this component
// as we have various use cases to have a radio group with out the need for
// such things and it makes handling grid styles much easier this way.

class UpdatedRadioGroup extends UpdatedInputBase {
  static propTypes = {
    className: string,
    disabled: bool,
    idRoot: string.isRequired,
    input: object.isRequired,
    meta: object.isRequired,
    options: array.isRequired,
  }

  static defaultProps = {
    className: '',
  }

  render () {
    const {
      className,
      disabled,
      idRoot,
      input,
      options,
    } = this.props

    return (
      <UpdatedRadioGroupWrapper className={`updated-radio-group ${className}`}>
        {options.map(o => (
          <Radio
            key={`${idRoot}-${o.value}`}
            {...input}
            {...o}
            checked={input.value === o.value}
            disabled={disabled}
            onChange={this.handleChange}
            id={`${idRoot}-${o.value || 'null'}`} />
        ))}
      </UpdatedRadioGroupWrapper>
    )
  }
}

export default UpdatedRadioGroup
